<div class="modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2 class="mb-0075"> Update Information</h2>
  <ng-container *ngIf="formControl">
    <app-name-form [entityType]="entityType"
                   [formControl]="formControl"
                   [showPronounsOnLoad]="data.showPronounsOnLoad">
    </app-name-form>

    <div class="col__ mt-0075">
      <button class="btn floatRight"
              type="button"
              data-test-id="saveBasicInfoButton"
              [appButtonSpinner]="isSaving"
              [disabled]="!formControl?.valid || isSaving"
              (click)="onSaveClicked()">Save</button>
    </div>
  </ng-container>

</div>
